import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-location-assignment-preferences-toggle',
    templateUrl: './location-assignment-preferences-toggle.component.html',
    styleUrls: ['./location-assignment-preferences-toggle.component.css']
})
export class LocationAssignmentPreferencesToggleComponent {

    @Input() checked;
    @Output('change') change: EventEmitter<boolean> = new EventEmitter();

}
